import {
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import CustomTable from 'src/ui-component/CustomTable/Index';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import CustomSelect from 'src/ui-component/CustomSelect';
import CustomSearchBar from 'src/ui-component/CustomSearchBar';
import CustomModal from 'src/ui-component/customModal/CustomModal';
import { httpRequest } from 'src/services/httpRequest';
import toast from 'react-hot-toast';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { useDispatch } from 'react-redux';
import AddTownship from './AddTownship';
import { columns, getData } from './TownshipManagementJsonV2';

const TownshipDetails: React.FC = () => {
  const dispatch = useDispatch();
  const [pagination, setpagination] = useState(0);
  const [isSearch, setIsSearch] = useState(0);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [customSelectValue, setcustomSelectValue] = useState('All');
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const [deleteUserid, setDeleteUserId] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [townshipAction, setTownshipAction] = useState<string>('');
  const [searchVal, setSearchVal] = useState('');

  const Action = (data: any) => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >  
      <Tooltip title="Edit" arrow>
        <IconButton
          onClick={() => {
            setTownshipAction(data);
          }}
        >
          <EditTwoToneIcon fontSize="small" color="primary" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete" arrow>
        <IconButton
          onClick={() => {
            setDeleteUserId(data.UserID);
            setIsOpen(true);
          }}
        >
          <DeleteForeverIcon fontSize="small" color="error" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  // Fetch data from API
  const handleApiCall = () => {
    getData('/townships?Page=1&Size=10', setRows, Action);
  };

  const handleDeleteApplication = async () => {
    setLoading(true);
    const response = await httpRequest(
      'DELETE',
      `/auth/deleteUser/${deleteUserid}`
    );
    if (response.status === 'success') {
      setIsOpen(false);
      toast.success('User deleted successfully.');
      handleApiCall();
    } else if (response.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
    setLoading(false);
  };

  // Fetch data from API on component mount
  useEffect(() => {
    if (rows.length === 0) handleApiCall();
    if (customSelectValue === 'All') {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter((data) => {
        return data.status.props.label === customSelectValue;
      });
      setFilteredRows(filteredData);
    }
  }, [customSelectValue, rows, townshipAction === '']);

  return (
    <>
      <Card>
        {townshipAction ? (
          <Box>
            <AddTownship
              setTownshipAction={setTownshipAction}
              handleApiCall={handleApiCall}
              townshipAction={townshipAction}
            />
          </Box>
        ) : (
          <Box sx={{ m: 3 }}>
            <Grid container gap={2} justifyContent={'space-between'}>
              <Grid item md={3} lg={3} xl={2} xs={12} sm={12}>
                <Button
                  onClick={() => setTownshipAction('Add')}
                  variant="contained"
                  size="large"
                >
                  Add New Township
                </Button>
              </Grid>

              <Grid item md={3} lg={3} xl={2} xs={12} sm={12}>
                <CustomSelect
                  setpagination={setpagination}
                  filterValue={customSelectValue}
                  setFilterValue={setcustomSelectValue}
                  title={'Filter by'}
                  options={[
                    { key: 'All', value: 'All' },
                    { key: 'Active', value: 'Active' },
                    { key: 'Inactive', value: 'Inactive' }
                  ]}
                />
              </Grid>

              <Grid item md={3} lg={3} xl={2} xs={12} sm={12}>
                <CustomSearchBar
                  rows={rows}
                  setFilteredRows={setFilteredRows}
                  setpagination={setpagination}
                  setIsSearch={setIsSearch}
                  searchVal={searchVal}
                  setSearchVal={setSearchVal}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 3 }}>
              <CustomTable
                pagination={pagination}
                setSelectedRowData={() => {}}
                rows={filteredRows}
                columns={columns}
                isSearch={isSearch}
              />
            </Box>
          </Box>
        )}
      </Card>

      <CustomModal
        title={'Delete User?'}
        IsOpen={IsOpen}
        setIsOpen={setIsOpen}
        onSave={handleDeleteApplication}
        actionButtons={['No', 'Yes']}
        loading={loading}
        content={
          <Typography>Are you sure you want to delete this user?</Typography>
        }
      />
    </>
  );
};

export default TownshipDetails;
